var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconanalyticsReportWhite = function SvgIconanalyticsReportWhite(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Analytics/icon.analytics_report_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L12.1926923,0 C12.4684565,-1.15912868e-16 12.7319806,0.113876937 12.9209598,0.314707095 L18.2282676,5.95483557 C18.402812,6.14032572 18.5,6.38542791 18.5,6.64012847 L18.5,23 C18.5,23.5522847 18.0522847,24 17.5,24 L1,24 C0.44771525,24 6.76353751e-17,23.5522847 0,23 L0,1 C-6.76353751e-17,0.44771525 0.44771525,7.67586877e-16 1,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Analytics/icon.analytics_report_24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.42391304,
    y1: 18.5,
    x2: 4.42391304,
    y2: 14.5,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.64130435,
    y1: 18.4666667,
    x2: 7.64130435,
    y2: 11.2666667,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.8586957,
    y1: 18.48,
    x2: 10.8586957,
    y2: 12.88,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.076087,
    y1: 18.4666667,
    x2: 14.076087,
    y2: 11.1333333,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.076087,
    y1: 18.4666667,
    x2: 14.076087,
    y2: 11.2666667,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M12.1926923,1 L17.5,6.64012847 L17.5,23 L1,23 L1,1 L12.1926923,1 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "11.8253555 6.75160604e-14 14.9040384 3.1303492 18.5 6.78665796 11.8253555 6.78665796"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconanalyticsReportWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.analytics_report_white.5efa2897460da39a32070ceefe391119.svg";